module.exports = __webpack_public_path__ + "img/dashed-line.545fc620.svg";